import { useState } from "react";

import classNames from "classnames/bind";
import type { ImageProps } from "common/blocks/Image";
import Image from "common/blocks/Image";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Pagination, Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import styles from "./Gallery.module.scss";

const cx = classNames.bind(styles);

export interface GalleryProps {
    images: ImageProps[];
    showThumbnails?: boolean;
}

const Gallery = (props: GalleryProps) => {
    const { images, showThumbnails = true } = props;

    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    const handleSwiperInit = (swiperEl: any) => setThumbsSwiper(swiperEl);

    return (
        <div className={cx("container")}>
            <Swiper
                loop={true}
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                pagination={{
                    clickable: true,
                    dynamicBullets: true,
                }}
                modules={[Pagination, Navigation, Thumbs, FreeMode]}
                className={cx("hero")}
            >
                {images.map((image, i) => (
                    <SwiperSlide key={i}>
                        {
                            // eslint-disable-next-line jsx-a11y/alt-text
                            <Image {...image} layout="fill" objectFit="cover" />
                        }
                    </SwiperSlide>
                ))}
            </Swiper>
            {showThumbnails && (
                <Swiper
                    onSwiper={handleSwiperInit}
                    loop={false}
                    spaceBetween={20}
                    slidesPerView={3}
                    freeMode={false}
                    watchSlidesProgress={true}
                    className={cx("thumbnail")}
                    modules={[FreeMode]}
                >
                    {images.map((image, i) => (
                        <SwiperSlide key={i}>
                            {
                                // eslint-disable-next-line jsx-a11y/alt-text
                                <Image {...image} layout="fill" objectFit="cover" />
                            }
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </div>
    );
};

export default Gallery;
